// ----------------------------------------------------------------------

const shape = {
  borderRadius: 8,
  borderRadiusSm: 12,
  borderRadiusMd: 16
};

// Amik uses generous, soft radii (12 / 16 / 24). Other tenants keep 8 / 12 / 16.
export function createShape(isAmik = false) {
  if (!isAmik) return shape;
  return {
    borderRadius: 12,
    borderRadiusSm: 16,
    borderRadiusMd: 24
  };
}

export default shape;
